// extracted by mini-css-extract-plugin
export default {"product-warranty-returns_separator":"product-warranty-returns_separator_EqLtlJGa"};